import React from 'react'
import {Button, Card, CardBody, CardHeader, Col, Row} from 'reactstrap';

import {Button as SementicBtn} from 'semantic-ui-react'
import '../ViewAllCheckIn/ViewAllCheckIn.css'
import {MDBDataTable} from 'mdbreact'
import * as common from '../../../const/Common/CommonFunc';
import LabelInput from "../../../components/Input/LabelInput/LabelInput";
import LabelDropdown from "../../../components/Dropdown/LabelDropdown/LabelDropdown";
import {connect} from "react-redux";
import * as actionCreator from "../../../store/Action";
import Cookies from "js-cookie";
import axios from "../../../axios/axios_visitortag";
import {Empty, Tooltip} from "antd";
import Spinner from "../../../components/Spinner/Spinner";
import { DatePicker } from "antd";
import moment from "moment";
import '../../../react-antd.css'
import $ from "jquery";
import Download from '../../../components/Button/DownloadbleButton'
import apiConfig from "../../../axios/axios_api_services";
import CovidResult from "./CovidResult/CovidResult";
const { RangePicker } = DatePicker;

function disabledDate(current) {
  return current && current > moment().endOf("day");
}

class History extends React.Component {

  state = {
    selectedColumn: "",
    searchDetails: "",
    visitors_list: [],
    visitors_history: [],
    checkoutColumns: [

      {
        label: 'Tag Color',
        field: 'tagColor',
        sort: 'asc'
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'asc'
      },
      {
        label: 'Pass Number',
        field: 'passNumber',
        sort: 'asc'
      },
      {
        label: 'Checked In',
        field: 'checkedIn',
        sort: 'asc'
      },
      {
        label: 'Checked Out',
        field: 'checkedOut',
        sort: 'asc'
      },
      {
        label: 'Host 1',
        field: 'host1',
        sort: 'asc',
      },
      {
        label: 'Host 1 Mobile',
        field: 'host1Mobile',
        sort: 'asc',
      },
      {
        label: 'Host 2',
        field: 'host2',
        sort: 'asc',
      },
      {
        label: 'Host 2 Mobile',
        field: 'host2Mobile',
        sort: 'asc',
      },
      {
        label: 'Visitor',
        field: 'visitor',
        sort: 'asc',
      },
      {
        label: 'Visitor Identity',
        field: 'visitorIdentity',
        sort: 'asc',
      },
      {
        label: 'Visitor Mobile',
        field: 'visitorMobile',
        sort: 'asc',
      },
      {
        label: 'Company',
        field: 'company',
        sort: 'asc',
      },
      {
        label: 'Purpose of Visit',
        field: 'purposeOfVisit',
        sort: 'asc',
      },
      {
        label: 'Activated Package',
        field: 'activatedPackage',
        sort: 'asc',
      },
      {
        label: 'Generated pin',
        field: 'generatedPin',
        sort: 'asc',
      },
      {
        label: 'Expire Date',
        field: 'expireDate',
        sort: 'asc',
      },
      {
        label: 'Registration Status',
        field: 'registrationStatus',
        sort: 'asc'
      },
      {
        label:'Receptionist Name',
        field: 'receptionistName',
        sort: 'asc'
      },
      // {
      //   label:'COVID Result',
      //   field: 'covid',
      //   sort: 'asc'
      // }
    ],
    isCovidDetails: false,
    covidObj: null
  };

  DetailOnChange = (e, {value}) => {
    this.setState({selectedColumn: value});
  };
  DetailDescOnChange = (e) => {
    this.setState({searchDetails: e.target.value});
  };

  async buttonClick(e, type) {

    switch (type) {
      case 'details':
        if (this.state.searchDetails === null || this.state.selectedColumn === null || this.state.searchDetails.trim() === "" || this.state.selectedColumn.trim() === "") {
          common.notifyMessage("please select Column and fill Search Textd");

          this.setState({
            visitors_list: this.state.visitors_history
          })
        } else {

          let custom_array = [];

          let searchText = this.state.searchDetails.trim().toUpperCase();
          let searchCol = this.state.selectedColumn;

          let all_visitors = this.state.visitors_history;
          all_visitors.map((visitor, index) => {

            if (visitor[searchCol] !== null) {
              if (visitor[searchCol].toUpperCase().indexOf(searchText) > -1) {
                custom_array.push(visitor)
              }
            }
          });

          this.setState({
            visitors_list: custom_array
          })
        }

        break;
      case 'refresh':
        let start = new Date().setDate(new Date().getDate()-7);
        let end = new Date().setDate(new Date().getDate());
        this.getAllHistory(start,end);
        break;
      default:
    }
  };


  async getAllHistory (startDate,endDate) {
    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let coperateId = this.props.usr_obj.corporates[0].corporateId;
    // Get all history
    await axios.get(apiConfig.CORPORATE_VISITORS_HISTORY({corporateId:coperateId,startDate:startDate,endDate:endDate}), {headers: headers})
      .then(async response => {
        let _array = [];
        this.props.spinnerHandler(false);

        if (response.data.success) {
          let visitors = response.data.visitorList;

          if (visitors.length !== 0) {
            visitors.map((visitor, index) => {
              let obj = {...visitor};
              _array.push(obj);
            })
          }
        }

        this.setState({
          visitors_list: _array,
          visitors_history: _array
        });
      })

      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllHistory(startDate,endDate);
        } else {
          this.props.spinnerHandler(false)
        }
      })
  };

  fillData = () =>{
    $("#history-table > tbody > tr").each(function () {
      console.log($(this).find('td').eq(1).text())
      if($(this).find('td').eq(1).text() === "OVERDUE"){
        $(this).css("background-color", "rgb(255, 211, 211)") //#ff9696

      }
      if($(this).find('td').eq(1).text() === "CHECKED_OUT"){
        $(this).css("background-color", "rgb(251, 253, 215)") //rgb(249, 255, 150)
      }

      if($(this).find('td').eq(1).text() === "CHECKED_IN"){
        $(this).css("background-color", "rgb(214, 236, 247)") //rgb(175, 229, 255)
      }
    });
  };

  viewCovidDetails = (obj) => {
    this.setState({
      isCovidDetails: true,
      covidObj: obj
    })
  };

  componentDidMount() {
    let start = new Date().setDate(new Date().getDate()-7);
    let end = new Date().setDate(new Date().getDate());
    this.getAllHistory(start,end);

    this.fillData();
    $('#history-table').bind('DOMSubtreeModified', this.fillData.bind(this));
  }

  onChange = (date, dateString) => {
    if (dateString[0] === "" || dateString[1] === "") {

    } else {
      let start = new Date(dateString[0]);
      let end = new Date(dateString[1]);
      this.getAllHistory(start.getTime(),  end.getTime());
    }
  };

  render() {
    let rows = [];
    this.state.visitors_list.map((value, index) => {
      if (value.host1 !== "DEFAULT_USER") {
        rows.push(
          {
            tagColor: <Spinner type={1} size={30} isColor={value.tagColour !== null} color={value.tagColour}/>,
            status: value.status ? value.host1 === "DEFAULT_USER" ? "-" : value.status : value.status,
            passNumber: value.passNumber,
            checkedIn: value.checkedIn,
            checkedOut: value.checkedOut === null || value.host1 === "DEFAULT_USER" ? "-" : value.checkedOut,
            host1: value.host1 ? value.host1 === "DEFAULT_USER" ? "-" : value.host1 : value.host1,
            host1Mobile: value.host1Mobile ? value.host1Mobile === "94777777777" ? "-" : value.host1Mobile : value.host1Mobile,
            host2: value.host2 !== null ? value.host2 : "-",
            host2Mobile: value.host2Mobile !== null ? value.host2Mobile : "-",
            visitor: value.visitorName,
            visitorIdentity: value.visitorIdentity,
            visitorMobile: value.visitorMobile,
            company: value.company !== null ? value.company : "-",
            purposeOfVisit: value.visitingPurpose,
            activatedPackage: value.activatedPackage !== null ? value.activatedPackage : "Not requested",
            generatedPin: value.generatedPin !== null ? value.generatedPin : "Not requested",
            expireDate: value.expireDate !== null ? value.expireDate : "Not requested",
            registrationStatus: value.registrationStatus,
            receptionistName: value.receptionistName,
            covid: value.host1 === "DEFAULT_USER" ? <SementicBtn className={"covid-tbl-btn"}
                                                                 onClick={() => this.viewCovidDetails(value)}>View</SementicBtn> : null
          }
        )
      }
    });
    let columns = this.state.checkoutColumns;
    let data = {columns, rows};
    return (

      <div>
        {
          this.props.usr_obj.userRoles === "RECEPTION" ?
            <h4 className={"route-name-style"}>{this.props.route_name}</h4>
            :<h4 className={"route-none-style"}/>
        }
        {
          this.state.isCovidDetails ? <CovidResult obj={this.state.covidObj} closeModal={()=>this.setState({isCovidDetails:false})}/>:null
        }

        <Row>
          <Col xs="12" sm="12" md="12" lg="12" xl="12">
            <Card>
              <CardHeader>
                Search Details
              </CardHeader>

              <CardBody className=" paddingBottom">
                <div className="form-group paddingBottom">
                  <Row>
                    <Col xs="4" sm="4" md="4" lg="4" xl="4">
                      <LabelDropdown
                        clearable
                        required
                        btnText={"Search"}
                        tagText={"Select Column"}
                        placeholder={"Select Column"}
                        options={this.props.column}
                        onChange={this.DetailOnChange}
                      />
                      <RangePicker
                        size={"mini"}
                        defaultValue={[moment().subtract(7, "days"), moment().subtract(0, "days")]}
                        disabledDate={disabledDate}
                        format="YYYY-MM-DD"
                        onChange={this.onChange}
                      />
                    </Col>
                    <Col xs="4" sm="4" md="5" lg="5" xl="5">
                      <LabelInput
                        required
                        tagText={"Search"}
                        placeholder={"Search Details"}
                        // value={this.state.host_extension}
                        onChange={this.DetailDescOnChange}
                      />

                    </Col>

                    <Col xs="4" sm="4" md="3" lg="3" xl="3">
                      <Row>
                        <Col xs="10" sm="10" md="10" lg="10" xl="10">
                          <Button
                            className="height "
                            block
                            color="primary"
                            onClick={e => this.buttonClick(e, 'details')}
                          >Search</Button>
                        </Col>

                        <Col xs="2" sm="2" md="2" lg="2" xl="2" style={{padding: '0'}}>
                          <Tooltip placement="topLeft" title="Last 7days history">
                            <SementicBtn onClick={e => this.buttonClick(e, 'refresh')} circular icon='refresh'/>
                          </Tooltip>
                        </Col>
                      </Row>

                    </Col>

                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            <Card className="card margin0">
              <CardHeader>
                Visitors History
                <Download data={this.state.visitors_list} userType={"VISITOR_HISTORY"}/>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col lg="12">
                    {
                      this.state.visitors_list.length !== 0 ?
                        <MDBDataTable
                          id={"history-table"}
                          exportToCSV={true}
                          searching={true}
                          searchLabel={"Search visitor"}
                          responsive
                          responsiveSm
                          responsiveMd
                          responsiveLg
                          responsiveXl
                          // striped={true}
                          bordered
                          hover
                          data={data}/>
                        : <div className={"align-center fully-width"}>
                          <Empty description={"Records not found"} className={"empty-icon"}/>
                        </div>
                    }
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  visitors: state.viewAllCheckIN.visitors,
  checkInVisitors: state.viewAllCheckIN.checkInVisitors,
  historyColumns: state.viewAllCheckIN.historyColumns,
  column: state.viewAllCheckIN.column,

  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(History);
